import {Platform, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {silverChalice} from '/theme/color/on.color';
import {denim, grayscale, white} from '/theme/color/on.color';
import {
  blueShine,
  codGray,
  darkRed,
  wineRed,
} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    height: '100%',
  },
  content: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingStart: 16,
    paddingEnd: 16,
  },
  text: {
    fontSize: 24,
    lineHeight: 28,
  },
  passwordField: {
    marginTop: indent,
  },
  spacer: {
    marginVertical: indent * 1.5,
  },
  button: {
    marginBottom: indent,
    height: 53,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: denim,
  },
  forgotPasswordButton: {
    paddingHorizontal: 15,
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
  },
  forgotPasswordText: {
    color: denim,
    fontSize: 14,
  },
  error: {
    color: darkRed,
    marginTop: 2,
  },
  alertButtonIcon: {
    fontSize: 16,
    color: wineRed,
    marginLeft: indent,
  },
  alertView: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 4,
  },
  alertIcon: {
    color: wineRed,
    paddingStart: indent * 2,
    marginTop: 8,
    fontSize: 16,
  },
  emailError: {
    color: darkRed,
    marginTop: 6,
    marginLeft: 8,
  },
  errorPassword: {
    color: darkRed,
    marginTop: 8,
    marginLeft: 8,
  },
  loadingContainer: {
    height: 32,
    marginBottom: indent,
  },
  messageBanner: {
    position: 'absolute',
    top: 10,
    left: 0,
    right: 0,
    alignItems: 'center',
  },
  verticalBar: {
    width: 4,
    height: '100%',
    backgroundColor: blueShine,
    borderRadius: 8,
    marginLeft: 5,
    marginRight: 10,
  },
  infoIcon: {
    color: blueShine,
  },
  closeText: {
    color: codGray,
    paddingLeft: 16,
    flex: 1,
    fontWeight: 'bold',
  },
  crossIcon: {
    color: silverChalice,
    marginLeft: 'auto',
  },
  infoButtonsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  infoButtonsBottom: {
    paddingBottom: Platform.select({android: indent, ios: indent * 2}),
  },
  checkboxContainer: {
    flexDirection: 'row',
    marginTop: 10,
  },
  setupText: {
    fontSize: 14,
  },
  selectedIcon: {
    fontSize: 20,
    color: denim,
    marginLeft: indent * 2,
    marginRight: indent * 0.5,
  },
  unSelectedIcon: {
    fontSize: 20,
    borderColor: grayscale,
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 2,
    color: white,
    marginLeft: indent * 2,
    marginRight: indent * 0.5,
  },
});
